<template>
    <div>
        <!-- Ajustar Pagamento Particular -->
        <div class="modal fade" id="ajustePagParticModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ajustar Pagamento Particular</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="dados">
                        <div class="alert alert-info d-flex justify-content-between">
                            <div>
                                <div>
                                    <strong>Recibo #{{ dados.item.id_pagamento_atendimento }}</strong>
                                </div>
                                <div>
                                    {{ dados.item.forma_pagamento.search }}
                                </div>
                            </div>
                            <div class="text-right">
                                <div>{{ $util.formatMoeda(dados.item.dc_valor ) }}</div>
                            </div>
                        </div>

                        <div class="form-row mb-3">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    id="credito"
                                    label="Bandeira do Cartão de Crédito"
                                    placeholder="Selecione a Bandeira..."
                                    type="select"
                                    optionsMode="aql"
                                    service="bandeira_cartaos.index"
                                    optionsData="id_bandeira_cartao"
                                    optionsDisplay="search"
                                    :optionsName="'band_card.cre.index.'+ id_unidade_operacao"
                                    :optionsParm="{
                                        where: { ch_tipo: 'C' },
                                        id_unidade_operacao: id_unidade_operacao
                                    }"
                                    @change.native="false"
                                    icon="fas fa-credit-card fa-fw"
                                    v-model="dados.item.id_bandeira_cartao"
                                    required
                                    :validate="validate" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input 
                                    sizing="sm"
                                    label="Emissão"
                                    v-model="dt_emissao"
                                    required
                                    :validate="validate" 
                                    type="date" />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input 
                                    sizing="sm"
                                    label="Autorização/CV/NSU"
                                    v-model="dados.item.st_autorizacao" 
                                    required
                                    :validate="validate"
                                    placeholder="Informar..." />
                            </div>
                            <div class="col col-12 col-md-2">
                                <az-input 
                                    sizing="sm"
                                    label="Parcelas"
                                    v-model="dados.item.in_parcelas" 
                                    required
                                    :validate="validate"
                                    type="number">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-prepend">
                                            <button type="button" class="btn btn-outline-primary" @click="refresh_parcelas()">
                                                <i class="fa-solid fa-arrows-rotate"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div v-for="(parcela, idx) in dados.item.lancamentos" :key="idx">
                            <div class="form-row" v-show="!parcela.selecionado">
                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        sizing="sm"
                                        :label="index_1 == idx ? 'Parcela' : ''"
                                        v-model="parcela.in_parcela" 
                                        :edicao="false"
                                        type="number" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        sizing="sm"
                                        :label="index_1 == idx ? 'Vencimento' : ''"
                                        v-model="parcela.dt_vencimento" 
                                        required
                                        :validate="validate"
                                        type="date" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        sizing="sm"
                                        :label="index_1 == idx ? 'Valor' : ''"
                                        v-model="parcela.dc_valor" 
                                        required
                                        :validate="validate"
                                        :type="alterando_parcelas ? 'number' : 'money'" />
                                </div>
                            </div>
                        </div>

                        <pre v-if="false">{{ dados }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from "moment";
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            dados: null, 
            id_unidade_operacao: "", 
            validate: false, 
            alterando_parcelas: false, 
            dt_emissao: "", 
        }
    },

    components: { 
        AzInput, 
        AzSubmit 
    },
  
    computed: { 
        index_1: function () { 
            return this.dados.item.lancamentos.findIndex( item => !item.selecionado );
        }
    },

    methods: { 
        refresh_parcelas () { 

            if ( !this.dados.item.in_parcelas ) { 
                return; 
            }

            this.alterando_parcelas = true;
            
            this.$nextTick(() => { 
               
                let valor_parcela = Math.round( ( this.dados.item.dc_valor / this.dados.item.in_parcelas ) * 100 ) / 100;
                let resto = this.dados.item.dc_valor - ( valor_parcela * this.dados.item.in_parcelas );

                if ( this.dados.item.in_parcelas > this.dados.item.lancamentos.length ) { 
                    
                    let idx = this.dados.item.lancamentos.length;
                    let last = this.dados.item.lancamentos[idx - 1];
                    let venc = last ? last.dt_vencimento : null;

                    for ( let i = 0; i < this.dados.item.lancamentos.length; i++ ) { 
                        this.dados.item.lancamentos[i].selecionado = false;
                        this.dados.item.lancamentos[i].dc_valor = valor_parcela + ( i ? 0 : resto);
                    }

                    for ( let i = idx; i < this.dados.item.in_parcelas; i++ ) { 

                        venc = moment(venc).add(1, 'months').format('YYYY-MM-DD');

                        this.dados.item.lancamentos.push({ 
                            in_parcela: i + 1, 
                            dt_vencimento: venc, 
                            dc_valor: valor_parcela, 
                            selecionado: false
                        });

                    }

                } else if ( this.dados.item.in_parcelas < this.dados.item.lancamentos.length ) { 

                    for ( let i = 0; i < this.dados.item.lancamentos.length; i++ ) { 

                        this.dados.item.lancamentos[i].dc_valor = valor_parcela + ( i ? 0 : resto);

                        if ( i < this.dados.item.in_parcelas ) { 
                            this.dados.item.lancamentos[i].selecionado = false;
                        } else {
                            this.dados.item.lancamentos[i].selecionado = true;
                        }

                    }

                }

                this.alterando_parcelas = false;

            });

        },

        abrir(lancamento) { 

            if ( !lancamento.id_item_pagamento_atendimento ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Item de pagamento não identificado. (#" + lancamento.id_lancamento + ")",
                    life: 3000
                });
                return; 
            }

            this.dados = null; 

            this.$nextTick(() => { 
               
                this.$util.load(this, { 
                    service: 'financeiro', 
                    func: 'item_pg', 
                    parms: { 
                        id_item_pagamento_atendimento: lancamento.id_item_pagamento_atendimento, 
                    },
                    loadTo: res => { 
                        this.id_unidade_operacao = _.get(res, 'item.lancamentos.0.id_unidade_operacao', 1);
                        this.dt_emissao = _.get(res, 'item.lancamentos.0.dt_emissao');

                        this.dados = res;
                        $('.modal').modal('hide');
                        $('#ajustePagParticModal').modal('show');
                    }
                });

            });

        },

        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'financeiro', 
                func: 'atualizar_item_pg', 
                dados: { 
                    ...this.dados.item, 
                    dt_emissao: this.dt_emissao,
                },
                toast: true, 
                modal: 'ajustePagParticModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });

        }

    }

}
</script>
